/**
* 페이지 상단으로 자동 스크롤
*/
function scrollToTop() {
    window.scroll({ top: 0, behavior: "smooth" });
}

export default scrollToTop;